import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = n => (_pushScopeId("data-v-2a1ba89f"), n = n(), _popScopeId(), n);
var _hoisted_1 = ["id", "data-cy"];
var _hoisted_2 = ["data-cy"];
var _hoisted_3 = ["src", "alt"];
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = ["data-cy"];
var _hoisted_6 = ["src", "alt"];
var _hoisted_7 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    id: _ctx.$attrs['id'] || '',
    "data-cy": _ctx.$attrs['data-cy'] || '',
    class: _normalizeClass(["base-complex-toggle tw-flex tw-justify-center tw-p-0 tw-relative", [_ctx.mode, _ctx.borderContainerColor]])
  }, [_createElementVNode("div", {
    ref: "leftBtn",
    "data-cy": "bct-left-btn".concat(_ctx.labels.leftToggle.label ? "-".concat(_ctx.labels.leftToggle.label) : ''),
    class: "left-button tw-flex tw-flex-1 tw-items-center tw-justify-center hover:tw-cursor-pointer",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.handleToggle('left-btn'), ["stop"]))
  }, [_ctx.labels.leftToggle.icon ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "tw-mr-10px base-complex-toggle-icon tw-relative tw-z-10",
    src: _ctx.labels.leftToggle.icon.src,
    alt: _ctx.labels.leftToggle.icon.alt,
    width: "15",
    height: "15"
  }, null, 8 /* PROPS */, _hoisted_3)) : _createCommentVNode("v-if", true), _createElementVNode("span", {
    ref: "leftToggleLabel",
    class: "base-complex-toggle-label tw-relative tw-z-10",
    innerHTML: _ctx.labels.leftToggle.label
  }, null, 8 /* PROPS */, _hoisted_4)], 8 /* PROPS */, _hoisted_2), _createElementVNode("div", {
    ref: "rightBtn",
    "data-cy": "bct-right-btn".concat(_ctx.labels.rightToggle.label ? "-".concat(_ctx.labels.rightToggle.label) : ''),
    class: "right-button tw-flex tw-flex-1 tw-items-center tw-justify-center hover:tw-cursor-pointer",
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.handleToggle('right-btn'), ["stop"]))
  }, [_ctx.labels.rightToggle.icon ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "tw-mr-10px base-complex-toggle-icon tw-relative tw-z-10",
    src: _ctx.labels.rightToggle.icon.src,
    alt: _ctx.labels.rightToggle.icon.alt,
    width: "15",
    height: "15"
  }, null, 8 /* PROPS */, _hoisted_6)) : _createCommentVNode("v-if", true), _createElementVNode("span", {
    ref: "rightToggleLabel",
    class: "base-complex-toggle-label tw-relative tw-z-10",
    innerHTML: _ctx.labels.rightToggle.label
  }, null, 8 /* PROPS */, _hoisted_7)], 8 /* PROPS */, _hoisted_5), _createElementVNode("div", {
    ref: "dynamicBg",
    class: _normalizeClass(["tw-absolute tw-transition-all tw-duration-200 tw-ease-out", [_ctx.type === 'full' ? 'base-complex-toggle-active-bg' : 'base-complex-toggle-active-padded-bg', _ctx.btnBgColor, _ctx.mode]])
  }, null, 2 /* CLASS */)], 10 /* CLASS, PROPS */, _hoisted_1);
}